// The `new_season` remote-configuration flag (per-user via users_email,
// resolved server-side by GET remote_user_configurations). Default false:
// every New Season entry point and route renders nothing unless it is truthy.
const { useSelector } = require('react-redux');
const {
  get_configuration_config,
  FeatureFlagDictionary,
} = require('remoteConfigurationsManager');
const { findV2Distribution, findV2FarmingUnit } = require('./v2Distributions');

const isNewSeasonEnabled = (
  configurationData,
  farmingUnitName,
  distributionName,
) =>
  Boolean(
    configurationData?.configuration_data &&
    get_configuration_config(
      configurationData,
      FeatureFlagDictionary.NEW_SEASON,
      farmingUnitName,
      distributionName,
    ),
  );

// Inside the New Season pages: names come from GET v2/distributions only.
const useNewSeasonFlag = (distributionId, farmingUnitId) => {
  const configurationData = useSelector((state) => state.configuration_data);
  const distributions = useSelector(
    (state) => state.new_season_data?.distributions,
  );
  const distribution = findV2Distribution(distributions, distributionId);
  const farmingUnit = findV2FarmingUnit(
    distributions,
    distributionId,
    farmingUnitId,
  );
  return {
    loaded: Boolean(configurationData?.configuration_data),
    enabled: isNewSeasonEnabled(
      configurationData,
      farmingUnit?.name,
      distribution?.name,
    ),
  };
};

module.exports = { useNewSeasonFlag, isNewSeasonEnabled };
